import { useLayoutEffect } from 'react'
import { useSelector, useStore } from 'react-redux'
import { Script } from '@calendly/react-script-tag'
import { SafeSuspense } from '@calendly/safe-suspense'

import { isCookiesAllowedSelector } from 'selectors/gdpr'
import { Settings } from 'services/settings'
import { updateAnonymousId } from 'actions/segment'

const analyticsMethods = [
  'identify',
  'group',
  'track',
  'page',
  'pageview',
  'alias',
  'ready',
  'on',
  'once',
  'off',
  'trackLink',
  'trackForm',
  'trackClick',
  'trackSubmit'
]

const factory = (key) => (...args) => {
  args.unshift(key)
  window.analytics.push(args)
  return window.analytics
}

const setupApi = (store) => {
  if (!window.analytics) {
    window.analytics = []

    analyticsMethods.forEach((key) => {
      window.analytics[key] = factory(key)
    })

    window.analytics.methods = analyticsMethods
    window.analytics.factory = factory
    window.analytics.SNIPPET_VERSION = '2.0.9'
    window.analytics.ready(() => {
      // dispatch event to redux store to update anonymousId
      store.dispatch(updateAnonymousId(window.analytics.user().anonymousId()))
    })
  }
}

export const SegmentScript = () => {
  const isAllowed = useSelector(isCookiesAllowedSelector('performance'))
  const store = useStore()

  useLayoutEffect(() => {
    setupApi(store)
  }, [store])

  if (!Settings.segment.enabled) return null
  if (!isAllowed) return null

  return (
    <SafeSuspense fallback={null} onError={null}>
      <Script id="analytics-js" src={`https://cdn.segment.io/analytics.js/v1/${Settings.segment.client_write_key}/analytics.min.js`}>
        {null}
      </Script>
    </SafeSuspense>
  )
}
